<template>
  <div>
    <about-us-desktop v-if="screenType === 'desktop'"></about-us-desktop>
    <about-us-mobile v-else></about-us-mobile>
  </div>
</template>

<script>
import AboutUsDesktop from "@/components/Pages/Desktop/AboutUs/AboutUsDesktop";
import AboutUsMobile from "@/components/Pages/Mobile/AboutUs/AboutUsMobile";

export default {
  name: "AboutUsMain",
  components: {AboutUsMobile, AboutUsDesktop},
  data() {
    return {
      screenType: window.screen.width < 500 ? 'mobile' : window.screen.width < 1000 ? 'tablet' : 'desktop'
    }
  }
}
</script>

<style scoped>

</style>